module.exports = __webpack_public_path__ + "static/img/hero.3c5016b1.webp";